import {
  formatJaneNameByStatus,
  statusesThatImplyMainJaneIsDefined,
} from 'utils/formatJaneNameByStatus';
import { JaneNameWrapper } from './JaneName.styled';
import { IJaneNameProps } from './JaneName.types';
import { HTMLAttributes, useCallback } from 'react';
import { janeDetailsModalRoutingService } from 'components/JaneDetailsModal/JaneDetailsModal.constants';

export const JaneName = (props: IJaneNameProps & HTMLAttributes<HTMLDivElement>): JSX.Element => {
  const { status, mainJane, ...rest } = props;

  const handleJaneNameClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      if (mainJane?.id) {
        janeDetailsModalRoutingService.open({ janeId: mainJane.id });
      }
    },
    [mainJane?.id],
  );

  const shouldShowUnderline = mainJane && statusesThatImplyMainJaneIsDefined.includes(status);

  return (
    <JaneNameWrapper
      {...rest}
      onClick={
        shouldShowUnderline ? (e) => handleJaneNameClick(e as unknown as MouseEvent) : undefined
      }
      isUnderlined={shouldShowUnderline ?? false}
    >
      {formatJaneNameByStatus({ status, mainJane })}
    </JaneNameWrapper>
  );
};
